import { combineReducers } from 'redux';
import { reservationsReducer } from './containers/Booking/services/reducer';

export const managerModuleReducer = combineReducers({
  reservationsReducer,
});

export type ManagerModuleState = ReturnType<typeof managerModuleReducer>;
